export const darkTheme = {
  current: "dark",
  body: "#1F1F23",
  textColor: "#fff",
  borderColor: "#B1B1B1",
  bgColor: "#2C2C2C",
  subtitleColor: "#C0C0C0",
  hover: "#2D2D31",
  buttonBg: "#484849",
};

export const lightTheme = {
  current: "light",
  body: "#FFFFFF",
  textColor: "#2E2E34",
  borderColor: "#B1B1B1",
  bgColor: "#FAFAFA",
  subtitleColor: "#747474",
  hover: "#F2F3FF",
  buttonBg: "#D9E8FF",
};
